import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { EnergyMapComponent } from '../energy-map.component';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';

@Injectable({
  providedIn: 'root',
})
export class EnergyMapCanDeactivateGuard implements CanDeactivate<EnergyMapComponent> {
  constructor(public overlayLoaderService: OverlayLoaderService) {}

  canDeactivate(
    component: EnergyMapComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (component.isScenarioEdited) {
      component.energyMapService.scenarioPlannerSaveChanges(true);
      this.overlayLoaderService.isLoading = false;

      return component.energyMapService.scenarioPlannerClose$.pipe(
        mergeMap((val) => {
          if (val) {
            this.overlayLoaderService.isLoading = true;
            return of(true);
          }

          return of(false);
        })
      );
    } else {
      return true;
    }
  }
}
